export function shouldBeArray(value: any) {
  if (!Array.isArray(value)) {
    return [value]
  }
  return value
}
